const Loading = ({ size = 12, color = 'white' }) => {
  return (
    <div className='flex items-center justify-center'>
      <div
        className={`animate-spin rounded-full size-${size} border-t-2 border-${color}`}
      ></div>
    </div>
  );
};

export default Loading;
